import { render, staticRenderFns } from "./FollowObservationStats.vue?vue&type=template&id=54b64068&"
import script from "./FollowObservationStats.vue?vue&type=script&lang=js&"
export * from "./FollowObservationStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports